import Vue from 'vue'
import moment from "moment";
import accounting from "accounting";
import VuetableFieldSequence from 'vuetable-2/src/components/VuetableFieldSequence.vue'
import VuetableFieldCheckbox from 'vuetable-2/src/components/VuetableFieldCheckbox.vue'
Vue.component('vuetable-field-checkbox', VuetableFieldCheckbox)

export default [

  // {
  //   name: 'vuetable-field-checkbox',
  //   title: "checkbox",
  //   width: "5%"
  // },
  {
    name: "client-name",
    title: 'Client Name',
    width: "250px",
    sortField: "name"
  },
  {
    name: "claim-type",
    title: "Type",
    width: "350px",
    sortField: "claimType"
  },
  {
    name: "name",
    title: 'Industry',
    width: "250px",
    sortField: "name"
  },
  {
    name: "analyst",
    title: 'Analyst',
    width: "200px"
  },
  {
    name: "fye",
    title: 'FYE',
    width: "400px",
    sortField: "fiscalMonth"
  }, 
  {
    name: "reviewStatus",
    title: 'Review Status',
    width: "400px"
  },

]